import { DutyScheduleColumnResponse } from "@/api";
import {
  DutyScheduleTableColumns,
  DutyScheduleTableLayout,
} from "@/pages/duty-schedule/pages/duty-schedule-detail/components/table-layout/DutyScheduleTableLayout";
import {
  DutyScheduleOverviewRow,
  TOTALS_KEY,
} from "@/pages/duty-schedule/pages/duty-schedule-detail/pages/counselor-overview/DutyScheduleCounselorOverview.utils";
import { useTranslation } from "@/translations";

import { buildCounselorColumn, buildDutyColumns, buildSumColumn } from "./DutyScheduleCounselorOverviewTable.utils";

interface Props {
  columns: DutyScheduleColumnResponse[];
  unfilledRow: DutyScheduleOverviewRow | null;
  counselorRows: DutyScheduleOverviewRow[];
  totalsRow: DutyScheduleOverviewRow;
}

export function DutyScheduleCounselorOverviewTable({ columns, unfilledRow, counselorRows, totalsRow }: Props) {
  const { t } = useTranslation();

  const tableColumns: DutyScheduleTableColumns<DutyScheduleOverviewRow> = [
    buildCounselorColumn(t),
    ...buildDutyColumns(columns),
    buildSumColumn(t),
  ];
  const data = [...(unfilledRow != null ? [unfilledRow] : []), ...counselorRows, totalsRow];

  return (
    <DutyScheduleTableLayout
      ariaLabel={t("dutySchedule.detail.counselorOverview.tableAria")}
      columns={tableColumns}
      data={data}
      getRowId={(row) => row.key}
      isRowHoverable={(row) => row.key !== TOTALS_KEY}
    />
  );
}
